import { EvmDashboardActionTypes } from "./EvmDashboard.type";

const initialState = {
  fetchOne: {
    error: null,
    isPending: false,
    payload: null,
  },
};

const EvmDashboardReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case EvmDashboardActionTypes.FETCH_EVM_DASHBOARD:
      return { ...state, fetchOne: { error: null, isPending: true, payload: null } };
    case EvmDashboardActionTypes.FETCH_EVM_DASHBOARD_SUCCESS:
      return { ...state, fetchOne: { error: null, isPending: false, payload: action.payload } };
    case EvmDashboardActionTypes.FETCH_EVM_DASHBOARD_FAILURE:
      return { ...state, fetchOne: { error: action.payload, isPending: false, payload: null } };
    case EvmDashboardActionTypes.FETCH_EVM_DASHBOARD_RESET:
      return { ...state, fetchOne: { error: null, isPending: false, payload: null } };
    default:
      return state;
  }
};

export default EvmDashboardReducer;
